<template>
    <header id="top" class="hero">
        <div class="ob-dots hero-dots" />
        <div class="ob-arc hero-arc-1" />
        <div class="ob-arc hero-arc-2" />
        <div class="hero-signal">
            <div class="sig sig-1" />
            <div class="sig sig-2" />
            <div class="sig sig-3" />
            <div class="sig sig-4" />
            <div class="sig sig-5" />
        </div>
        <div class="hero-grid">
            <div>
                <div class="hero-eyebrow">Fibre · Wireless · 5G · Satellite — Freetown</div>
                <h1 class="hero-h1">Never Disconnect,<br><span class="hero-grad">Just Play.</span></h1>
                <p class="hero-body">Fibre-grade speed, rock-solid reliability and support that actually answers — from a team that lives here.</p>
                <div class="hero-ctas">
                    <ObButton href="#offer" variant="primary" size="lg">See our offerings ↓</ObButton>
                    <ObButton href="#technology" variant="inverse" size="lg">How the network works</ObButton>
                </div>
            </div>
            <div class="hero-proof">
                <div v-for="p in HERO_PROOF" :key="p.k" class="hero-proof-row">
                    <span class="hero-proof-k">{{ p.k }}</span>
                    <span class="hero-proof-v">{{ p.v }}</span>
                </div>
            </div>
        </div>
    </header>
</template>

<script lang="ts" setup>
    import ObButton from '@/components/ObButton.vue'
    import { HERO_PROOF } from '@/data/content'
</script>

<style scoped>
    .hero { position: relative; max-width: 1240px; margin: 0 auto; padding: 96px 44px 88px; }
    .hero-dots { position: absolute; right: 44px; top: 70px; width: 250px; height: 170px; opacity: .55; pointer-events: none; }
    .hero-arc-1 { position: absolute; right: -140px; bottom: -60px; width: 420px; height: 420px; pointer-events: none; }
    .hero-arc-2 { position: absolute; right: -60px; bottom: 20px; width: 260px; height: 260px; pointer-events: none; }

    .hero-signal { display: flex; flex-direction: column; gap: 6px; margin-bottom: 38px; }
    .sig { height: 3px; }
    .sig-1 { width: 210px; background: var(--ob-sky); }
    .sig-2 { width: 132px; background: var(--ob-blue); }
    .sig-3 { width: 176px; background: var(--ob-blue-deep); }
    .sig-4 { width: 96px; background: var(--ob-magenta); }
    .sig-5 { width: 150px; background: var(--ob-pink); }

    .hero-grid { display: grid; grid-template-columns: 1.45fr .55fr; gap: 56px; align-items: end; }
    .hero-eyebrow {
        font-size: 12px;
        font-weight: 600;
        letter-spacing: .16em;
        text-transform: uppercase;
        color: var(--ob-blue-deep);
        margin-bottom: 22px;
    }
    .hero-h1 {
        margin: 0;
        font-weight: 800;
        letter-spacing: -.035em;
        line-height: .98;
        font-size: clamp(52px, 7.4vw, 104px);
        color: var(--ob-ink);
    }
    .hero-grad {
        background: var(--ob-grad-hero-text);
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
    }
    .hero-body {
        font-size: clamp(18px, 1.55vw, 21px);
        line-height: 1.5;
        color: var(--ob-ink-soft);
        max-width: 540px;
        margin: 30px 0 40px;
    }
    .hero-ctas { display: flex; flex-wrap: wrap; gap: 14px; }

    .hero-proof { display: grid; border-top: 1px solid var(--ob-navy-a16); }
    .hero-proof-row {
        display: flex;
        align-items: baseline;
        justify-content: space-between;
        gap: 14px;
        padding: 20px 0;
        border-bottom: 1px solid var(--ob-navy-a11);
    }
    .hero-proof-k { font-size: 12px; font-weight: 600; letter-spacing: .12em; text-transform: uppercase; color: var(--ob-ink-sub); }
    .hero-proof-v { font-size: 30px; font-weight: 800; letter-spacing: -.02em; line-height: 1; color: var(--ob-ink); }

    @media (max-width: 1024px) {
        .hero-grid { grid-template-columns: 1fr; gap: 36px; }
        .hero-arc-1, .hero-arc-2 { display: none; }
    }
    @media (max-width: 700px) {
        .hero { padding: 56px 20px 56px; }
        .hero-dots { right: 20px; top: 40px; width: 150px; height: 110px; }
        .hero-signal { margin-bottom: 28px; }
        .hero-body { margin: 24px 0 30px; }
        .hero-proof-v { font-size: 24px; }
        .hero-proof-row { padding: 14px 0; }
    }
    @media (max-width: 480px) {
        .hero-h1 { font-size: clamp(40px, 12vw, 52px); }
    }
</style>
